export default class Move {
    constructor() {
        this.manaCost = 10;
    }
}
